import React, { useState, useEffect } from 'react';
import SectionCaseStudiesItem from './SectionCaseStudiesItem';

const CASE_STUDIES_PARENT_URL = `${process.env.PUBLIC_URL || ''}/case-studies/index.json`;
const FEATURED = 2;

/** Homepage Case Studies teaser — featured only; full list on Case Studies page. */
export default function SectionCaseStudies() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    fetch(CASE_STUDIES_PARENT_URL)
      .then((res) => {
        if (!res.ok) throw new Error('Failed to load case studies');
        return res.json();
      })
      .then((json) => {
        if (!cancelled) setData(json);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  if (loading) return null;
  if (error || !data) return null;

  const allList = Array.isArray(data.items) ? data.items : [];
  if (allList.length === 0) return null;

  const heading = data.heading ?? 'Case studies';
  const subtext = data.subtext ?? '';
  const list = allList.slice(0, FEATURED);
  const hasMore = allList.length > FEATURED;

  return (
    <section id="casestudies" className="py-12 sm:py-16 border-t" style={{ background: 'var(--jb-forest-bg)', borderColor: 'var(--jb-border)' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="mb-10 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
          <div>
            <p className="font-mono text-xs text-cyan uppercase tracking-widest mb-2">Deep dives</p>
            <h2 className="font-display font-extrabold text-2xl sm:text-3xl text-text-hero mb-2">{heading}</h2>
            {subtext && <p className="font-body text-text-sub max-w-xl">{subtext}</p>}
          </div>
          <a
            href="#casestudies"
            className="font-body font-semibold text-cyan text-sm hover:opacity-90 whitespace-nowrap"
          >
            View all case studies →
          </a>
        </div>
        <div className="grid sm:grid-cols-2 gap-5">
          {list.map((item) => (
            <SectionCaseStudiesItem
              key={item.slug || item.title}
              title={item.title ?? ''}
              description={item.shortDescription ?? item.description ?? ''}
              href={item.slug ? `#casestudy/${item.slug}` : (item.href ?? '#')}
              date={item.date ?? ''}
              internal={!!item.slug}
            />
          ))}
        </div>
        {hasMore && (
          <div className="mt-8 text-center">
            <a
              href="#casestudies"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl border font-body font-semibold text-sm text-text-body hover:border-cyan hover:text-cyan transition"
              style={{ borderColor: 'var(--jb-border)' }}
            >
              See all {allList.length} case studies →
            </a>
          </div>
        )}
      </div>
    </section>
  );
}
